<template>
  <div class="main-div" v-if="stats.length > 0">
    <!--  secondary stats-->
    <div class="secondary-stats">
      <!--    users stats-->
      <ul class="responsive-table" v-if="!CheckUserPermission([7])">
        <li class="table-header">
          <div class="col col-1">#</div>
          <div class="col col-2">Users({{ getUsersStats(stats).length }})</div>
          <div class="col col-3">Count</div>
        </li>
        <li class="table-row" v-for="(user,idx) in getUsersStats(stats)" :key="user">
          <div class="col col-1">
            #{{idx+1}}
          </div>
          <div
            class="col col-2"
            v-tooltip.top="{
              content: user.name
            }"
          >
              {{ user.name.split(" ")[0] }}
          </div>
          <div class="col col-3 count">
           {{ user.count }}
          </div>
        </li>
      </ul>

      <!--    countries stats-->
      <ul class="responsive-table hrs">
        <li class="table-header">
          <div class="col col-1">#</div>
          <div class="col col-2">Cn({{ getCountriesStats(stats).length }})</div>
          <div class="col col-3">Count</div>
        </li>
        <li
          class="table-row"
          v-for="(country,idx) in getCountriesStats(stats)"
          :key="country.id"
        >
          <div
            class="col col-1"
          >
            #{{idx+1}}
          </div>

          <div
            class="col col-2"
            v-tooltip.top="{
              content: getCountryStats(country.id).name
            }"
          >
          <img
              :src="
                `/img/flags/` +
                  getCountryStats(country.id).alpha2.toLowerCase() +
                  `.png`
              "
            />
          </div>

          <div class="col col-3 count">
            {{ country.count }}
          </div>
        </li>
      </ul>

      <!--    reasons stats-->
      <ul class="responsive-table reasons">
        <li class="table-header">
          <div class="col col-1">#</div>
          <div class="col col-2">Res({{ getReasonsStats(stats).length }})</div>
          <div class="col col-3">Count</div>
        </li>
        <li
          class="table-row"
          v-for="(res,idx) in getReasonsStats(stats)"
          :key="res.id"
        >
          <div
            class="col col-1"

          >
            #{{idx+1}}
          </div>
          <div
            class="col col-2"
            v-tooltip.top="{
              content: res.type
            }"
          >
          {{ res.type.substring(0, 10) }}
          </div>

          <div class="col col-3 count">
            {{ res.count }}
          </div>
        </li>
      </ul>


      <!--    hours stats-->
      <ul class="responsive-table reasons hrs">
        <li class="table-header">
          <div class="col col-1">#</div>
          <div class="col col-2">HR({{ getHRStats(stats).length }})</div>
          <div class="col col-3">Count</div>
        </li>
        <li
          class="table-row"
          v-for="(hr,idx) in getHRStats(stats)"
          :key="idx"
        >
          <div
            class="col col-1"

          >
            #{{idx+1}}
          </div>
          <div
            class="col col-2"
            v-tooltip.top="{
              content: hr.hour.start + ' - ' + hr.hour.finish
            }"
          >
            <i
                :class="hr.hour.icon"
            ></i>
          </div>

          <div class="col col-3 count">
            {{ hr.count }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import moment from "moment";
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ScheduledCallsStatsPopUp.component",
  mixins: [UsersPermissionCheck],
  props: {
    today: {
      required: true,
      type: Boolean
    },
    tomorrow:{
      type:Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      stats: [],
      waitingForFetchSc: false,
      timeIcons:[
          {
            icon:'fas fa-sun',
            start:'06:00:00',
            finish:'12:00:00',
          },
          {
            icon:'fas fa-cloud-sun',
            start:'12:00:00',
            finish:'18:00:00',
          },
          {
            icon:'fas fa-cloud-moon',
            start:'18:00:00',
            finish:'00:00:00',
          },
          {
            icon:'fas fa-moon',
            start:'00:00:00',
            finish:'06:00:00',
          },
      ],
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "generalQueryObject"])
  },
  mounted() {
    this.fetchStats();
  },
  watch:{
    tomorrow:function(){
      this.fetchStats();
    },
    generalQueryObject:function(){
      this.fetchStats();
    },

  },
  methods: {

    fetchStats() {
      this.stats = [];
      let queryParams = this.generalQueryObject;
      if (this.today) {
        queryParams.today_stats = 1;
      }
      if(this.tomorrow){
        delete queryParams.today_stats;
        queryParams.tomorrow_stats = 1;
      }
      apiClientCreator(`reports/scheduled_calls/sc_all_stats`)
        .get("", { params: queryParams })
        .then(res => {
          this.waitingForFetchSc = true;
          this.stats = this.sortNextCalls(res.data.data);
        });
      this.waitingForFetchSc = false;
    },
    sortNextCalls(stats) {
      let arr = stats;
      if (arr.length > 0) {
        arr = arr.sort((a, b) => {
          if (
            a.scheduled_calls[0].scheduled_on <
            b.scheduled_calls[0].scheduled_on
          ) {
            return -1;
          }
          if (
            a.scheduled_calls[0].scheduled_on <
            b.scheduled_calls[0].scheduled_on
          ) {
            return 1;
          }
          return 0;
        });
      }
      return arr;
    },
    sortSubStats(stats) {
      let arr = stats;
      if (arr.length > 0) {
        arr = arr.sort((a, b) => {
          if (a.count > b.count) {
            return -1;
          }
          if (a.count < b.count) {
            return 1;
          }
          return 0;
        });
      }
      return arr;
    },
    getCountryStats(countryId) {
      return this.dictionaries.general.countries.find(
        country => country.id == countryId
      );
    },
    getSCStats(call) {
      return call.scheduled_calls[0];
    },
    formatCallTime(call) {
      return this.today
        ? moment(call).format("H:mm")
        : moment(call).format("YYYY-MM-DD H:mm");
    },
    getDiffInMin(call) {
      let fCall = moment(call.scheduled_on);
      return (
        moment(fCall).diff(moment(), "minutes") +
        `:${moment(fCall).diff(moment(), "seconds") % 60}`
      );
    },
    filterNextCalls() {
      this.$emit("filterNextCalls");
      this.$emit("closeNextCalls");
    },
    closeNextCalls() {
      this.$emit("closeNextCalls");
    },
    filterClientId(val) {
      this.$store.commit("clients/setFilterClientById", val);
    },

    getUsersStats(arr) {
      let counts = {};
      let tempArr = [];
      arr.forEach(x => {
        counts[this.getSCStats(x).user.full_name] =
          (counts[this.getSCStats(x).user.full_name] || 0) + 1;
      });

      Object.keys(counts).map(key => {
        tempArr.push({
          name: key,
          count: counts[key]
        });
      });
      return this.sortSubStats(tempArr);
    },
    getCountriesStats(arr) {
      let counts = {};
      let tempArr = [];
      arr.forEach(x => {
        counts[x.country_id] = (counts[x.country_id] || 0) + 1;
      });

      Object.keys(counts).map(key => {
        tempArr.push({
          id: key,
          count: counts[key]
        });
      });
      return this.sortSubStats(tempArr);
    },
    getReasonsStats(arr) {
      let counts = {};
      let tempArr = [];
      arr.forEach(x => {
        counts[this.getSCStats(x).status.id] = {
          count:
            ((counts[this.getSCStats(x).status.id] &&
              counts[this.getSCStats(x).status.id].count) ||
              0) + 1,
          type: this.getSCStats(x).status.type
        };
      });

      Object.keys(counts).map(key => {
        tempArr.push({
          id: key,
          count: counts[key].count,
          type: counts[key].type
        });
      });
      return this.sortSubStats(tempArr);
    },
    getHRStats(arr){
     let hrs = this.timeIcons;
      let counts = {};
      let tempArr = [];
      arr.forEach(x => {
        let hour = parseInt(moment(this.getSCStats(x).scheduled_on).format('H'));
        let type = 1;
        if( hour >= 6 && hour < 12 ){
          type = 1
        }
        if( hour >= 12 && hour < 18 ){
          type = 2
        }
        if( hour >= 18 && hour < 24 ){
          type = 3
        }
        if( hour >= 0 && hour < 6 ){
          type = 4
        }

        counts[type] =
            (counts[type] || 0) + 1;
      });
      Object.keys(counts).map(key => {
        tempArr.push({
          hour: key === "1" ? hrs[0] : (key === "2" ? hrs[1]:(key === "3" ? hrs[2]:(key === "4" ? hrs[3]:hrs[0]))),
          count: counts[key]
        });
      });
      return tempArr;
    },

  }
};
</script>

<style scoped>
.main-div {
  /*margin: 15px 15px 0px 15px;*/
  height: 185px;
  overflow-y: hidden;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);

}
.btn:focus {
  outline: none;
}
.buttons-wrapper {
  display: flex;
  justify-content: space-between;
}
.container {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.responsive-table {
  padding-left: 5px;
  min-width: 170px;
}
h2 {
  font-size: 13px;
  margin: 5px 0;
  text-align: center;
}
h2 small {
  font-size: 0.5em;
}

.responsive-table li {
  border-radius: 3px;
  padding: 15px 15px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.responsive-table .table-header {
  background-color: #ffa72c;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 5px;
  padding: 2px;
}
.responsive-table .table-row {
  background-color: #ffffff;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 5px;
  padding: 5px;
  font-size: 11px;
  display: flex;
  justify-content: space-between;
}
.count{
  font-weight: bold;
}
.responsive-table .col-1 {
  flex-basis: 15%;
}
.responsive-table .col-2 {
  justify-content: left;
  flex-basis: 60%;
}
.responsive-table .col-3 {
  flex-basis: 20%;
}
.responsive-table .col-4 {
  flex-basis: 25%;
}
@media all and (max-width: 767px) {
  .responsive-table .table-header {
    display: none;
  }
  .responsive-table li {
    display: block;
  }
  .responsive-table .col {
    flex-basis: 100%;
  }
  .responsive-table .col {
    display: flex;
    padding: 10px 0;
  }
  .responsive-table .col:before {
    color: #6c7a89;
    padding-right: 10px;
    content: attr(data-label);
    flex-basis: 50%;
    text-align: right;
  }
}
.col {
  text-align: center;
}
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2000; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  //background-color: rgba(184, 184, 184, 0.4); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 60%;
  /*max-width: 700px;*/
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}
.table-row:hover {
  cursor: pointer;
  background-color: #e0e0e0;
}
.main-table {
  max-height: 167px;
  margin-bottom: 15px;
  overflow-y: scroll;
}
.secondary-stats {
  max-height: 175px;
  margin-bottom: 15px;
  overflow-y: scroll;
  display: flex;
}
hr {
  margin-top: 3px;
  margin-bottom: 3px;
}
.reasons {
  min-width: 170px;
}
.hrs{
  min-width: 145px;

}
</style>
